<wl-card heading="Credit Report">
  <div main-container>
    <!-- <nav mat-tab-nav-bar> -->
      <!-- <a mat-tab-link fxFlex.gt-xs="20" fxFlex.xs="33" [routerLink]="['/laas/creditview']" routerLinkActive="active">View Report</a> -->
      <!-- Uncomment the line below if you want to add another tab link -->
      <!-- <a mat-tab-link fxFlex.gt-xs="20" fxFlex.xs="33" [routerLink]="['/laas/creditgenerate']" routerLinkActive="active">Generate Report</a> -->
    <!-- </nav> -->
    <!-- <router-outlet></router-outlet> -->
    <cibil-view></cibil-view>
  </div>
</wl-card>
